import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  template: `
    <main>
      <router-outlet></router-outlet>
    </main>
  `,
  styles: [],
  standalone: true,
  imports: [RouterModule, CommonModule]
})
export class AppComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    if (window.location.hostname.indexOf('evtest.wonder-sys.com') !== -1) {
      console.log('TIS app. Loading TIS home assets.', window.location.hostname);
      this.setFavicon('/assets/img/logoTISv3.ico');
    }

    if (window.location.hostname.indexOf('extraglass') !== -1) {
      console.log('Extraglass app. Loading Extraglass home assets.', window.location.hostname);
      this.setFavicon('/assets/img/extraglass.png');
    }
  }

  setFavicon(url: string) {
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.setAttribute('type', 'image/x-icon');
    link.setAttribute('rel', 'shortcut icon');
    link.setAttribute('href', url);
    document.getElementsByTagName('head')[0].appendChild(link);
  }
}
